define('presentation/settings/callQueues/facades/addCallQueueFacade',[
    'externalDependencies/clientWebSocket',
], function() {
    const callQueueSocket = require('externalDependencies/clientWebSocket').forApplication("callQueue");

    let _promiseFactory = null;

    const _getCallQueue = (accountCallQueueId) => {
        return _promiseFactory.defer((promise) => {
            callQueueSocket.send("getCallQueue", {accountCallQueueId: accountCallQueueId}, (result, err) => {
                if (err) {
                    promise.reject(new Error(err));
                    return;
                }

                promise.resolve(result);
            });
        });
    };

    const _getCallQueues = () => {
        return _promiseFactory.defer((promise) => {
            callQueueSocket.send("getCallQueueList", {}, (result, err) => {
                if (err) {
                    promise.reject(new Error(err));
                    return;
                }

                promise.resolve(result.callQueues);
            });
        });
    };

    const _create = (callQueue) => {
        return _promiseFactory.defer((promise) => {
            callQueueSocket.send("createCallQueue", _buildSaveRequest(callQueue), (result, err) => {
                if (err) {
                    promise.reject(new Error(err));
                    return;
                }

                promise.resolve(result);
            });
        });
    };

    const _update = (callQueue) => {
        return _promiseFactory.defer((promise) => {
            callQueueSocket.send("updateCallQueue", _buildSaveRequest(callQueue), (result, err) => {
                if (err) {
                    promise.reject(new Error(err));
                    return;
                }

                promise.resolve(result);
            });
        });
    };

    const _buildSaveRequest = (callQueue) => {
        return {
            accountCallQueueId: callQueue.accountCallQueueId,
            name: callQueue.name,
            welcomeVoicePromptId: callQueue.welcomeVoicePromptId,
            welcomeSystemAudioClipId: callQueue.welcomeSystemAudioClipId,
            queueFullRoutingRule: callQueue.queueFullRoutingRule,
            pools: callQueue.pools
        };
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        const self = this;

        self.init = _init;
        self.create = _create;
        self.getCallQueue = _getCallQueue;
        self.getCallQueues = _getCallQueues;
        self.update = _update;
    };
});

